import { render } from "./LayoutBase.vue?vue&type=template&id=1b6e916e"
import script from "./LayoutBase.vue?vue&type=script&lang=js"
export * from "./LayoutBase.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__